import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { Dashboard } from "@/pages/Dashboard";
import { Signals } from "@/pages/Signals";
import { SignalDetail } from "@/pages/SignalDetail";
import { Rejected } from "@/pages/Rejected";
import { PaperTrading } from "@/pages/PaperTrading";
import { Logs } from "@/pages/Logs";
import { Settings } from "@/pages/Settings";
import { Backtest } from "@/pages/Backtest";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/signals" element={<Signals />} />
            <Route path="/signals/:id" element={<SignalDetail />} />
            <Route path="/rejected" element={<Rejected />} />
            <Route path="/paper" element={<PaperTrading />} />
            <Route path="/logs" element={<Logs />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/backtest" element={<Backtest />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
